import { useCategories } from '@/hooks/useServices'
import { useCreateOffering } from '@/hooks/useOfferings'
import { useState } from 'react'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import Select from '@/components/forms/Select/Select'
import './ProviderAddOffering.css'

const ProviderAddOffering = () => {
    const { data: categories } = useCategories()
    const create = useCreateOffering()
    const [service, setService] = useState('')
    const [description, setDescription] = useState('')
    const [price, setPrice] = useState('')
    const [lat, setLat] = useState('')
    const [lng, setLng] = useState('')
    const [radius, setRadius] = useState('')

    const handleCreate = async () => {
        if (!service || !price || !lat || !lng || !radius) return
        await create.mutateAsync({
            service: Number(service),
            description,
            price_per_hour: Number(price),
            service_location_latitude: Number(lat),
            service_location_longitude: Number(lng),
            service_radius_km: Number(radius),
        })
        setService(''); setDescription(''); setPrice(''); setLat(''); setLng(''); setRadius('')
    }

    return (
        <div className="provider-add-offering-page">
            <div className="provider-add-offering-container">
                <h1 className="provider-add-offering-title">Agregar Servicio</h1>
                <div className="provider-add-offering-form">
                    <Select label="Servicio" value={service} onChange={(e) => setService(e.target.value)} options={(categories || []).map((c: any) => ({ value: c.id, label: c.name }))} placeholder="Selecciona un servicio" />
                    <Input name="description" placeholder="Descripción" value={description} setValue={setDescription} multiline rows={4} effect3d={false} />
                    <Input name="price" placeholder="Precio por hora" value={price} setValue={setPrice} effect3d={false} />
                    <Input name="lat" placeholder="Latitud" value={lat} setValue={setLat} effect3d={false} />
                    <Input name="lng" placeholder="Longitud" value={lng} setValue={setLng} effect3d={false} />
                    <Input name="radius" placeholder="Radio (km)" value={radius} setValue={setRadius} effect3d={false} />
                    <Button variant="primary" onClick={handleCreate} disabled={create.isPending || !service || !price || !lat || !lng || !radius} effect3d={false}>Crear Servicio</Button>
                </div>
            </div>
        </div>
    )
}

export default ProviderAddOffering


